import { useMutation } from '@apollo/client/react';
import { Button, Descriptions, Flex, Form, Input, message, Modal, Typography } from 'antd';
import { useState } from 'react';

import { Spacer } from '../../components/Spacer';
import { UPDATE_ADMIN_PASSWORD } from '../../gqls/admin';
import { useAdmin } from '../../hooks/use-admin';

export const PageProfile = () => {
  const { admin } = useAdmin();

  const [messageApi, contextHolder] = message.useMessage();

  const [updatePasswordVisible, setUpdatePasswordVisible] = useState(false);

  const [updateAdminPassword, { loading }] = useMutation(UPDATE_ADMIN_PASSWORD, {
    onCompleted: () => {
      messageApi.success('Пароль изменен');
      setUpdatePasswordVisible(false);
    },
    onError: (err) => {
      console.error(err);
      messageApi.error(
        err.message === 'password-error' ? 'Неправильный пароль' : 'Произошла ошибка, повторите еще раз',
      );
    },
  });

  const handleUpdatePassword = (values) => {
    updateAdminPassword({
      variables: { data: { newPassword: values.newPassword, currentPassword: values.currentPassword } },
    });
  };

  return (
    <>
      {contextHolder}
      <Typography.Title level={5} style={{ margin: 0 }}>
        Профиль
      </Typography.Title>
      <Spacer h={12} />
      <Descriptions>
        <Descriptions.Item label="Электронная почта">{admin.email}</Descriptions.Item>
      </Descriptions>
      <Spacer h={16} />
      <Flex>
        <Button onClick={() => setUpdatePasswordVisible(true)}>Изменить пароль</Button>
      </Flex>
      <Modal
        title="Изменить пароль"
        open={updatePasswordVisible}
        onClose={() => setUpdatePasswordVisible(false)}
        onCancel={() => setUpdatePasswordVisible(false)}
        footer={[
          <Button key="back" onClick={() => setUpdatePasswordVisible(false)}>
            Отмена
          </Button>,
          <Button key="submit" type="primary" loading={loading} form="update-password-form" htmlType="submit">
            Изменить
          </Button>,
        ]}
      >
        <Form name="update-password-form" layout="vertical" onFinish={handleUpdatePassword}>
          <Form.Item
            name="currentPassword"
            label="Текущий пароль"
            rules={[{ required: true, message: 'Обязательное поле' }]}
          >
            <Input.Password />
          </Form.Item>
          <Form.Item name="newPassword" label="Новый пароль" rules={[{ required: true, message: 'Обязательное поле' }]}>
            <Input.Password />
          </Form.Item>
          <Form.Item
            name="repeatPassword"
            label="Повторите пароль"
            rules={[
              { required: true, message: 'Обязательное поле' },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue('newPassword') === value) return Promise.resolve();
                  return Promise.reject(new Error('Пароли должны совпадать'));
                },
              }),
            ]}
          >
            <Input.Password />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};
